import { Box, Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SeatAreaContext } from '../../../../../contexts/SeatAreaContext';
import { WebSocketContext } from '../../../../../contexts/WebSocketContext';
import { useBetSource } from '../../../../../hooks/useBetSource';
import { CMDPsMakeDecision } from '../../../../../models/cmd/live';
import { BlackjackDecision } from '../../../../../models/games/blackjack';
import { SeatLabel } from './Seat/SeatLabel';

export const InsurancePanel = () => {
    const { sendCommand } = useContext(WebSocketContext);
    const { selectedSeat, setShowInsurance, gameId } =
        useContext(SeatAreaContext);
    const betSource = useBetSource();
    const { t } = useTranslation();
    return selectedSeat ? (
        <Box
            sx={{
                position: 'absolute',
                width: '100%',
                top: '470px',
            }}
        >
            <Grid container direction={'column'}>
                <Grid container justifyContent={'center'}>
                    <SeatLabel sn={selectedSeat} />
                </Grid>
                <Grid
                    container
                    justifyContent={'center'}
                    textAlign={'center'}
                    spacing={2}
                >
                    <Grid item>
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => setShowInsurance(false)}
                        >
                            <rect
                                width="64"
                                height="64"
                                rx="32"
                                fill="#322A1D"
                                fillOpacity="0.8"
                            />
                            <g clipPath="url(#clip0_852_150654)">
                                <path
                                    d="M31.9973 29.6436L40.2473 21.3936L42.604 23.7502L34.354 32.0002L42.604 40.2502L40.2473 42.6069L31.9973 34.3569L23.7473 42.6069L21.3906 40.2502L29.6406 32.0002L21.3906 23.7502L23.7473 21.3936L31.9973 29.6436Z"
                                    fill="white"
                                />
                            </g>
                            <circle
                                cx="32"
                                cy="32"
                                r="27.5"
                                stroke="white"
                                strokeOpacity="0.2"
                            />
                            <defs>
                                <clipPath id="clip0_852_150654">
                                    <rect
                                        x="12"
                                        y="12"
                                        width="40"
                                        height="40"
                                        rx="8"
                                        fill="white"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <Typography>{t('blackjack.bet.no')}</Typography>
                    </Grid>
                    <Grid item>
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                                const command = new CMDPsMakeDecision();
                                command.GameID = gameId;
                                command.BetSource = betSource;
                                command.Decision = BlackjackDecision.Insurance;
                                sendCommand(command);
                                setShowInsurance(false);
                            }}
                        >
                            <rect
                                width="64"
                                height="64"
                                rx="32"
                                fill="#6F5F45"
                                fillOpacity="0.8"
                            />
                            <path
                                d="M48 31.9783C48.0184 40.7921 40.8668 47.9743 32.0457 47.9999C23.2135 48.0262 16.0165 40.8658 16 32.0375C15.9836 23.198 23.1325 16.0191 31.9707 16C40.8036 15.981 47.9815 23.1361 48 31.9783ZM41.3603 31.9941C41.3564 26.8338 37.1699 22.6466 32.0076 22.6387C26.8406 22.6308 22.6305 26.8437 22.639 32.0118C22.6482 37.1853 26.8182 41.3534 31.9918 41.3606C37.1732 41.3678 41.3643 37.1774 41.3597 31.9941H41.3603ZM39.9001 39.8677C38.84 40.95 37.6312 41.7218 36.2815 42.314C36.6698 43.2594 37.0455 44.1753 37.4265 45.1036C39.1908 44.3812 40.7121 43.3647 41.9848 42.0554C41.2853 41.3211 40.6075 40.6099 39.9001 39.8677ZM26.5761 18.899C24.8165 19.628 23.2806 20.6465 22.0066 21.9196C22.7134 22.6565 23.3997 23.3717 24.0986 24.1013C25.1481 23.0578 26.3675 22.2795 27.7184 21.6854C27.3295 20.7366 26.9564 19.8267 26.5761 18.899ZM18.8974 37.4254C19.6107 39.1795 20.6247 40.702 21.9751 42.0462C22.6798 41.3073 23.3642 40.5908 24.0604 39.8611C23.0602 38.8538 22.2705 37.6544 21.6888 36.2819C20.7504 36.6661 19.8331 37.0418 18.898 37.4248L18.8974 37.4254ZM18.8967 26.5752C18.1584 28.3254 17.8195 30.1104 17.8241 31.9802H20.8491C20.8544 30.5051 21.1347 29.0991 21.6875 27.722C20.7557 27.3391 19.8483 26.9667 18.8967 26.5752ZM26.5787 45.1036C28.3304 45.8307 30.1177 46.1879 31.9826 46.1728V43.1515C30.5033 43.1476 29.0898 42.8574 27.7198 42.314C27.3315 43.2621 26.9604 44.17 26.5787 45.1036ZM37.4239 18.895C35.665 18.189 33.8863 17.8173 32.0234 17.8265V20.7958C32.7643 20.8879 33.4862 20.9386 34.1909 21.0774C34.8931 21.2156 35.5781 21.4426 36.2993 21.638C36.6626 20.7517 37.0343 19.8451 37.4239 18.895ZM45.1092 37.4103C45.7297 36.3247 46.3891 32.9408 46.1699 32.0263H43.1884C43.1772 33.5073 42.8896 34.9121 42.35 36.2799C43.295 36.6675 44.2031 37.0392 45.1092 37.4103ZM39.9844 24.1487C40.9411 25.1073 41.7301 26.3186 42.3158 27.6865C43.2653 27.2963 44.1813 26.9206 45.096 26.5443C44.4643 24.9284 42.9903 22.746 41.9835 21.9531C41.3261 22.6749 40.6628 23.4033 39.9844 24.148V24.1487ZM36.9949 37.005H34.8306L33.9646 34.2745H30.0065L29.1892 37.005H27.067L30.9172 24.9481H33.0315L36.9949 37.005ZM33.3217 32.2349L31.9562 27.7608L30.6165 32.2349H33.321H33.3217Z"
                                fill="white"
                                fillOpacity="0.6"
                            />
                            <circle
                                cx="32"
                                cy="32"
                                r="27.5"
                                stroke="white"
                                strokeOpacity="0.2"
                            />
                        </svg>
                        <Typography>{t('blackjack.bet.insurance')}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    ) : (
        <></>
    );
};
